/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

export const GroupType = {
  USER_DEFINED: 'USER_DEFINED',
  SYSTEM: 'SYSTEM',
  CLOUDADMIN_ACL: 'CLOUDADMIN_ACL'
} as const

export type GroupTypeValue = (typeof GroupType)[keyof typeof GroupType]
